<template>
<box-view class="admin-dashboard" title="Quản trị" :showBack="false">
    <div class="container-fluid py-2">
        <!-- QUICK MENU -->
        <div class="row mb-4">
            <div v-for="menu in menus" :key="menu.title" class="col-md-2 col-6 mb-3">
                <div class="menu-box text-center" @click="navigate(menu)" style="cursor: pointer;">
                    <i :class="menu.icon"></i>
                    <div>{{ menu.title }}</div>
                </div>
            </div>
        </div>

        <!-- TODAY SUMMARY -->
        <h5 class="mb-3">
            <i class="fas fa-chart-bar me-1"></i>
            Hoạt động hôm nay
        </h5>

        <div class="row mb-4">
            <div class="col-md-4">
                <div class="summary-box bg-success">
                    <div>Tiền bán hàng</div>
                    <h4>{{ todayRevenue.toLocaleString() }}₫</h4>
                </div>
            </div>

            <div class="col-md-4">
                <div class="summary-box bg-info">
                    <div>Số đơn hàng</div>
                    <h4>{{ todayOrders.length }}</h4>
                </div>
            </div>

            <div class="col-md-4">
                <div class="summary-box bg-danger">
                    <div>Hàng khách trả</div>
                    <h4>
                        {{ todayReturnOrders.length }} đơn
                    </h4>
                </div>
            </div>

        </div>
        <div class="row">
            <!-- SẢN PHẨM BÁN TRONG NGÀY -->
            <div class="mb-4 col-md-6">
                <div class="card dashboard-card">
                    <div class="card-header bg-primary text-white">
                    Sản phẩm đã bán hôm nay
                </div>
                <div class="card-body p-0">
                    <table class="table table-sm table-bordered mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Tên sản phẩm</th>
                                <th>Số lượng</th>
                                <th>Doanh thu</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in soldToday" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.quantity }}</td>
                                <td class="text-danger">
                                    {{ item.total.toLocaleString() }}₫
                                </td>
                            </tr>
                            <tr v-if="soldToday.length === 0">
                                <td colspan="4" class="text-center text-muted">
                                    Chưa có sản phẩm bán hôm nay
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
             
            </div>
            <!-- đơn hoàn trong ngày -->
            <div class="mb-4 col-md-6">
                <div class="card dashboard-card">
                    <div class="card-header bg-danger text-white">
                    Đơn hoàn hôm nay
                </div>
                <div class="card-body p-0">
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Mã hoàn</th>
                                <th>Đơn gốc</th>
                                <th>Khách</th>
                                <th>Tiền hoàn</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(o, i) in todayReturnOrders" :key="o.id">
                                <td>{{ i + 1 }}</td>
                                <td>{{ o.id }}</td>
                                <td>{{ o.orderId }}</td>
                                <td>{{ o.customer.name }}</td>
                                <td class="text-danger fw-bold">
                                    {{ o.totalRefund.toLocaleString() }}
                                </td>
                            </tr>

                            <tr v-if="!todayReturnOrders.length">
                                <td colspan="5" class="text-center text-muted">
                                    Không có đơn hoàn hôm nay
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
</div>
             
            </div>

        </div>

        <!-- MONTH ACTIVITY -->
        <div class="row">
            <div class="col-md-6">
                <div class="card dashboard-card">
                    <div class="card-header bg-primary text-white">
                        Hoạt động (tháng này)
                    </div>
                    <div class="card-body">
                        <div class="d-flex justify-content-between mb-2">
                            <span>Doanh thu</span>
                            <b>{{ monthRevenue.toLocaleString() }}₫</b>
                        </div>
                        <div class="d-flex justify-content-between mb-2" v-if="canViewProfit">
                            <span>Lợi nhuận (ước tính)</span>
                            <b>{{ monthProfit.toLocaleString() }}₫</b>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                            <span>Tổng số đơn</span>
                            <b>{{ monthOrders.length }}</b>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span>Đơn trả hàng</span>
                            <b>{{ monthReturnOrders.length }}</b>
                        </div>
                    </div>
                </div>
            </div>

            <!-- PRODUCT INFO -->
            <div class="col-md-6">
                <div class="card dashboard-card">
                    <div class="card-header bg-success text-white">
                        Thông tin hàng hóa
                    </div>
                    <div class="card-body">
                        <div class="d-flex justify-content-between mb-2">
                            <span>Số loại hàng hóa</span>
                            <b>{{ products.length }} </b>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                            <span>Chưa có giá bán</span>
                            <b>{{ noSalePriceCount }}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</box-view>
</template>

<script>
export default {
    name: 'AdminDashboard',
    props: {
        products: {
            type: Array,
            default: () => []
        },
        orders: {
            type: Array,
            default: () => []
        },
        returnOrders: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        },
        settings: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            menus: [{
                    title: 'Sản phẩm',
                    icon: 'fas fa-box',
                    routeName: 'productlist'
                },
                {
                    title: 'Danh mục',
                    icon: 'fas fa-layer-group',
                    routeName: 'category'
                },
                {
                    title: 'Khách hàng',
                    icon: 'fas fa-users',
                    routeName: 'customer'
                },
                {
                    title: 'Đơn hàng',
                    icon: 'fas fa-file-invoice',
                    routeName: 'orderhistory'
                },
                {
                    title: 'Đơn đã in',
                    icon: 'fas fa-print',
                    routeName: 'printedbills'
                },
                {
                    title: 'Công nợ',
                    icon: 'fas fa-wallet',
                    routeName: 'debt'   
                },
                {
                    title: 'Đơn hoàn',
                    icon: 'fas fa-undo',        
                    routeName: 'returnhistory'   
                },
                {
                    title: 'Nhập Kho',
                    icon: 'fas fa-dolly',     
                    routeName: 'importhistory'   
                },
                {
                    title: 'Thu Chi',
                    icon: 'fas fa-money-check-alt', 
                    routeName: 'transaction'   
                },
                {
                    title: 'Nhà Cung Cấp',
                    icon: 'fas fa-truck',
                    routeName: 'supplier'     
                },

                {
                    title: 'Báo cáo',
                    icon: 'fas fa-chart-line',
                    routeName: 'revenuereport'
                },
                {
                    title: 'Cấu hình',
                    icon: 'fas fa-cog',
                    routeName: 'settings'
                },
                {
                    title: 'Tài khoản',
                    icon: 'fas fa-user-shield',
                    routeName: 'user'
                },
                {
                    title: 'Thông báo',
                    icon: 'fas fa-bell',
                    routeName: 'notifications'
                }
            ]
        };
    },

    computed: {
        canViewProfit() {
            const role = this.user.role || 'admin';
            if(role === 'admin') return true;
            const roleConfig = this.settings.user?.roles?.[role];
            return roleConfig?.permissions?.includes('viewProfit');
        },
        todayOrders() {
            // TODO: API INTEGRATION - Fetch dashboard stats from backend
            // GET /api/dashboard/summary
            const today = new Date().toDateString();
            return this.orders.filter(
                o =>
                !o.isReturn &&
                new Date(o.createdAt).toDateString() === today
            );
        },

        todayRevenue() {
            return this.todayOrders.reduce((sum, o) => sum + parseFloat(o.totalBill || o.totalPay || 0), 0);
        },

        monthOrders() {
            const m = new Date().getMonth();
            return this.orders.filter(
                o =>
                !o.isReturn &&
                new Date(o.createdAt).getMonth() === m
            );
        },

        monthRevenue() {
            return this.monthOrders.reduce((sum, o) => sum + parseFloat(o.totalBill || o.totalPay || 0), 0);
        },

        monthProfit() {
            if (!this.canViewProfit) return 0; // Security check logic
            return this.monthOrders.reduce((sum, o) => {
                const cart = o.cart || [];
                return (
                    sum +
                    cart.reduce(
                        (s, i) => {
                           const price = parseFloat(i.price || i.product?.price || 0);
                           const cost = parseFloat(i.cost || i.product?.costPrice || 0);
                           const qty = parseFloat(i.quantity || 0);
                           return s + (price - cost) * qty;
                        },
                        0
                    )
                );
            }, 0);
        },

        noSalePriceCount() {
            return this.products.filter(p => !p.price).length;
        },

        noCostPriceCount() {
            return this.products.filter(p => !p.cost).length;
        },
        soldToday() {
            const map = {};
            this.todayOrders.forEach(order => {
                const cart = order.cart || [];
                cart.forEach(item => {
                    const productId = item.productId || item.product?.id || item.id || 'unknown';
                    const productName = item.name || item.product?.name || 'Sản phẩm không tên';
                    const price = parseFloat(item.price || item.product?.price || 0);
                    const qty = parseFloat(item.quantity || 0);

                    if (!map[productId]) {
                        map[productId] = {
                            name: productName,
                            quantity: 0,
                            total: 0
                        };
                    }

                    map[productId].quantity += qty;
                    map[productId].total += qty * price;
                });
            });

            return Object.values(map);
        },
        // ===== ĐƠN TRẢ =====
        todayReturnOrders() {
            const today = new Date().toDateString()
            return this.returnOrders.filter(
                o => new Date(o.createdAt).toDateString() === today
            )
        },

        monthReturnOrders() {
            const m = new Date().getMonth();
            return this.returnOrders.filter(
                o => new Date(o.createdAt).getMonth() === m
            );
        },

        todayReturnAmount() {
            return this.todayReturnOrders.reduce(
                (sum, o) => sum + parseFloat(o.totalRefund || 0),
                0
            )
        },

    },
    methods: {
        navigate(menu) {
            if (menu.routeName) {
                this.$router.push({
                    name: menu.routeName
                });
            } else {
                this.$toast?.('Chức năng đang phát triển');
            }
        }
    }
};
</script>
